import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantStore } from "@/stores/restaurantStore";

/** Single path for sign-out: destroy session, then clear tenant + React Query cache. */
export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clearRestaurantState = useRestaurantStore(
    (s) => s.clearRestaurantState
  );

  return useCallback(async () => {
    // Sign out first so no query observer can re-fetch with the dying session
    await supabase.auth.signOut();
    clearRestaurantState();
    queryClient.clear();
    navigate("/signin", { replace: true });
  }, [clearRestaurantState, queryClient, navigate]);
}
